<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  <p class="message-text"
     [matTooltip]="data.fullMessage || data.message"
     [matTooltipDisabled]="!data.fullMessage"
     matTooltipPosition="above">
    {{ data.message }}
  </p>
</div>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancelClick()">
    {{ data.buttons.cancel }}
  </button>
  <button mat-button (click)="onConfirmClick()" cdkFocusInitial>
    {{ data.buttons.confirm }}
  </button>
</mat-dialog-actions>
